export default __webpack_public_path__ + "9205570dc1a6fa7b387dd18849a63f6d.png";